import { doc, getDoc } from 'firebase/firestore';
import { db } from './config';
import { authedFetch } from '../utils/api';

/**
 * The sermon catalog: one small document ({ id, title, publishDate,
 * videoUrl, thumbnailUrl } per sermon) instead of every transcript.
 * Served from Firestore (`catalog/videoIndex`, public read); if it has not
 * been built yet, the videoIndex function builds it on first request.
 */

let cache = null;
let inflight = null;

export async function getVideoIndex({ force = false } = {}) {
  if (cache && !force) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const snap = await getDoc(doc(db, 'catalog', 'videoIndex'));
      const data = snap.exists() ? snap.data() : null;
      if (data && Array.isArray(data.videos) && data.videos.length) {
        cache = data.videos;
        return cache;
      }
    } catch (err) {
      console.warn('catalog read failed, falling back to function:', err);
    }
    try {
      const response = await authedFetch('videoIndex', {});
      if (response.ok) {
        const data = await response.json();
        cache = Array.isArray(data.videos) ? data.videos : [];
        return cache;
      }
    } catch (err) {
      console.warn('videoIndex function failed:', err);
    }
    return cache || [];
  })();
  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

/** Publish dates are 'YYYY-MM-DD'; parse at noon local to avoid day shifts. */
export function catalogDate(publishDate) {
  if (!publishDate) return null;
  const d = new Date(`${publishDate}T12:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}
